export class EnumUtils {
  public static convertEnumToArray(e: any): string[] {
    return Object.values(e);
  }
}
